<app-entity-summary [entityDefinition]="entityDefinition" [entityObject]="entityObject"
  [displayWithRoundContainer]="false" [summaryErrorText]="summaryErrorText" [displaySidenavSvg]="false"
  [summaryTitle]="summaryTitle">
</app-entity-summary>